import React from "react";

export const NoTemplate: React.FC = () => {
  const styles = "text-gray-400 text-6xl";

  return <div className={styles}>No template selected</div>;
};

export default NoTemplate;
